import { OAuth2Token } from '@maximizer/core/shared/domain';
import { MILLISECONDS_PER_SECOND } from '../models/constants';

export const TOKEN_MAX_LIFESPAN_MS = 24 * 60 * 60 * 1000;
export const TOKEN_VALIDITY_SAFETY_MARGIN_MS = 60 * 1000;

// Server slides expiry by expires_in on each authenticated request, capped at TOKEN_MAX_LIFESPAN_MS after issuance.
export function getEffectiveExpiresAt(
  token: OAuth2Token | undefined,
  lastUseMs: number | undefined,
): number | null {
  if (
    !token?.expires_at ||
    typeof token.expires_in !== 'number' ||
    token.expires_in <= 0
  ) {
    return null;
  }

  const expiresAtMs = new Date(token.expires_at).getTime();
  if (Number.isNaN(expiresAtMs)) {
    return null;
  }

  const slidingWindowMs = token.expires_in * MILLISECONDS_PER_SECOND;
  const issuedAtMs = expiresAtMs - slidingWindowMs;
  const lastKnownUseMs = Math.max(issuedAtMs, lastUseMs ?? issuedAtMs);

  return Math.min(
    lastKnownUseMs + slidingWindowMs,
    issuedAtMs + TOKEN_MAX_LIFESPAN_MS,
  );
}

export function isTokenEffectivelyValid(
  token: OAuth2Token | undefined,
  lastUseMs: number | undefined,
  nowMs: number,
  safetyMarginMs: number = TOKEN_VALIDITY_SAFETY_MARGIN_MS,
): boolean {
  const effectiveExpiresAt = getEffectiveExpiresAt(token, lastUseMs);
  if (effectiveExpiresAt === null) {
    return false;
  }

  return nowMs < effectiveExpiresAt - safetyMarginMs;
}
